<template>
  <div ref="chart" class="chart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: ['label', 'dataBloodSugar'],
  data() {
    return {}
  },
  mounted() {
    this.renderChart()
  },
  methods: {
    renderChart() {
      const chart = echarts.init(this.$refs.chart)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'line', snap: true },
        },
        legend: {},
        xAxis: {
          type: 'category',
          data: this.label,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: [
          {
            name: 'mg/dL',
            type: 'value',
            position: 'left',
            min: 50,
            max: 300,
          },
        ],
        series: [
          {
            name: '血糖',
            data: this.dataBloodSugar,
            color: '#C23373',
            type: 'line',
            label: {
              show: true,
              position: 'top',
            },
          },
        ],
      }
      chart.setOption(option)
    },
  },
  watch: {
    label() {
      this.renderChart()
    },
    dataBloodSugar() {
      this.renderChart()
    },
  },
}
</script>
<style scoped>
.chart {
  width: 600px;
  height: 400px;
}

@media (max-width: 600px) {
  .chart {
    width: 100vw;
    height: 100vw;
  }
}
</style>
